export default "__VITE_ASSET__b10b19f0__"